import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useLogin } from '../../model'
import { Button } from '@/common/ui/Form/Button'
import { Fieldset } from '@/common/ui/Form/Fieldset/Fieldset'
import { AuthTabs } from '../shared/AuthTabs'
import { Input, InputPassword, EMAIL_VALIDATION, PASSWORD_VALIDATION } from '@/common/ui/Form'
import { ROUTES } from '../../lib/constants'
import { OzonLoginButton } from './OzonLoginButton'

export const LoginForm = () => {
    const { mutation, register, handleSubmit, errors, onSubmit, setFocus, emailFromQuery } = useLogin()

    useEffect(() => {
        if (emailFromQuery) setFocus('password')
    }, [emailFromQuery, setFocus])

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label='Форма входа'
            className='w-full flex flex-col gap-[1.875rem]'
        >
            <AuthTabs />
            <Fieldset errorText={errors.email?.message} required>
                <Input
                    type='text'
                    size='lg'
                    placeholder='Email'
                    aria-label='Email'
                    className='w-full'
                    autoComplete='email'
                    {...register('email', {
                        required: EMAIL_VALIDATION.required,
                        pattern: EMAIL_VALIDATION.pattern,
                    })}
                />
            </Fieldset>
            <Fieldset errorText={errors.password?.message} required>
                <InputPassword
                    size='lg'
                    placeholder='Пароль'
                    className='w-full'
                    aria-label='Пароль'
                    autoComplete='current-password'
                    {...register('password', { required: PASSWORD_VALIDATION.required })}
                />
            </Fieldset>
            {errors.root && <div className='input-error text-center text-sm text-error'>{errors.root.message}</div>}
            <div className='flex flex-col gap-[0.625rem]'>
                <Button
                    variant='filled'
                    emphasis='accent'
                    size='xl'
                    className='w-full'
                    type='submit'
                    disabled={mutation.isPending}
                    loading={mutation.isPending}
                >
                    Войти
                </Button>
                <Button
                    variant='ghost'
                    emphasis='secondary'
                    size='lg'
                    className='w-full'
                    type='button'
                    as={Link}
                    to={ROUTES.AUTH.RECOVERY}
                >
                    Забыли пароль?
                </Button>
            </div>
            <div className='flex items-center gap-3' aria-hidden>
                <span className='h-px flex-1 bg-base-300' />
                <span className='text-sm text-base-content/60'>или</span>
                <span className='h-px flex-1 bg-base-300' />
            </div>
            <OzonLoginButton />
        </form>
    )
}
